module.exports ={
  invalidKey: function() {
    return 'Event key must be a string';
  },
  unknownCustomEventKey: function(key) {
    return 'Custom event "' + key + '" does not exist'
  }
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/ldclient-js/src/messages.js
// module id = 1203
// module chunks = 32